import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { Failure } from "../../../core/failure";
import { ICRUDRepo } from "../../../core/models";
import { getFilterDate, getProductHistoryList } from "../utils";
import { IProductHistory, productHistoryFromJson, productHistoryToJson } from "./entities";

interface IProductHistoryRepo extends ICRUDRepo<IProductHistory, {}> {
  getHistoryList: (searchQuery?: string) => Promise<IProductHistory[]>;
}

const URL = "v1/product-history";

const ProductHistoryRepoImplFactory = (apiClient: ApiClient): IProductHistoryRepo => {
  const r: IProductHistoryRepo = {
    ...generateCrudRepoFactory<IProductHistory, {}>(apiClient, URL, productHistoryFromJson, productHistoryToJson),
    getHistoryList: async (searchQuery) => {
      try {
        const res = await apiClient.get(`/${URL}`);
        const p: IProductHistory[] = res.data.map(productHistoryFromJson);
        const date = getFilterDate(searchQuery);
        const list = getProductHistoryList(p, date);
        return list;
      } catch (error) {
        const failure: Failure = {
          message: error.message ?? "Unhandled failure",
        };
        throw failure;
      }
    },
  };

  return r;
};

export const ProductHistoryRepoImpl = ProductHistoryRepoImplFactory(apiClient);
